export default __webpack_public_path__ + "images/kronelotteri_banner.jpeg";